import "./style/index.scss";
import dayjs from "dayjs";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, DatePickerProps, Divider, Form, Row, Select, Space, Table, Image, Input, Flex } from "antd";
import { ColumnsType } from "antd/lib/table/interface";
import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { FormaPagamentoRecebimentoModel } from "../../../../models/formaPagamentoRecebimento/formaPagamentoRecebimentoModel";
import { setModalCadastrarLancamentoBancario } from "../../../../redux/slices/lancamentoBancario/lancamentoBancarioSlice";
import { buscarFormaPagamentoRecebimento } from "../../../../services/formaPagamentoRecebimentoService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { atualizarTransferenciaBancario, buscarSaldoContaBanco, cadastrarTransferenciaBancaria } from "../../../../services/lancamentoBancarioService";
import { realParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import { TransferenciaBancariaModel } from "../../../../models/lancamentoBancario/transferenciaBancariaModel";
import { Vm_ContaBancoModel } from "../../../../models/contaBanco/vm_contaBancoModel";
import { buscarContaBanco } from "../../../../services/contaBancoService";
import { listarSorteio } from "../../../../services/sorteioService";
import { buscarEmpresa, buscarTodasEmpresa } from "../../../../services/empresaService";
import { toastWarning } from "../../../../util/toast";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";

dayjs.locale("pt-br");

interface FormProps {
  data: Date;
  saldoDia: number;
  idFormaPagamentoRecebimento: number;
  valor: number;
  idEmpresaO: number;
  idEmpresaD: number;
  historico: string | null;
  idSorteio: number;
  dataSorteio: Date;
}

const ModalLançamento = (props: any) => {
  //Estados globais
  const lancamentoBancarioState = useAppSelector((state) => state.lancamentoBancario);
  const formaPagamentoRecebimentoState = useAppSelector((state) => state.formaPagamentoRecebimento);
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const empresaState = useAppSelector((state) => state.empresa);

  //Hooks
  const dispatch = useAppDispatch();

  //Estados Locais
  const [form] = Form.useForm<FormProps>();
  const [selectedDestino, setSelectedDestino] = useState<React.Key[]>([]);
  const [selectedOrigem, setSelectedOrigem] = useState<React.Key[]>([]);
  const [bancoOrigem, setBancoOrigem] = useState<Vm_ContaBancoModel[]>([]);
  const [bancoDestino, setBancoDestino] = useState<Vm_ContaBancoModel[]>([]);

  const editar = Object.values(lancamentoBancarioState.detalheTransferencia).length !== 0;

  useEffect(() => {
    if (formaPagamentoRecebimentoState.list.length === 0) dispatch(buscarFormaPagamentoRecebimento(formaPagamentoRecebimentoState.busca));
    if (empresaState.list.length === 0) dispatch(buscarEmpresa(empresaState.busca));
    if (empresaState.listAll.length === 0) dispatch(buscarTodasEmpresa(null));

    if (editar) {
      form.setFieldsValue({
        data: dayjs(lancamentoBancarioState.detalheTransferencia.data),
        idEmpresaO: lancamentoBancarioState.detalheTransferencia.idEmpresaOrigem,
        idEmpresaD: lancamentoBancarioState.detalheTransferencia.idEmpresaDestino,
        idFormaPagamentoRecebimento: lancamentoBancarioState.detalheTransferencia.idFormaPagamentoRecebimento,
        valor: lancamentoBancarioState.detalheTransferencia.valor,
        historico: lancamentoBancarioState.detalheTransferencia.historico ?? "",
        idSorteio: lancamentoBancarioState.detalheTransferencia.idSorteio ?? 0,
        dataSorteio: dayjs(lancamentoBancarioState.detalheTransferencia.dataSorteio),
      });
      carregarListaEditar();
    } else {
      form.setFieldsValue({ data: dayjs(), idEmpresaO: props.idEmpresa, idEmpresaD: props.idEmpresa });
      carregarLista();
    }
  }, [props.idEmpresa, lancamentoBancarioState.detalheTransferencia]);

  const carregarLista = async () => {
    const searchEmpresaSorteios = empresaState.list.filter((empresa: any) => empresa.idEmpresaMarketing === props.idEmpresa);
    var listIdEmpresas = searchEmpresaSorteios.length !== 0 ? searchEmpresaSorteios[0].id + "," + props.idEmpresa : props.idEmpresa.toString();
    dispatch(listarSorteio(listIdEmpresas));

    let result = await dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: props.idEmpresa }));
    setBancoOrigem(result.payload.filter((a: Vm_ContaBancoModel) => a.ativo));
    setBancoDestino(result.payload.filter((a: Vm_ContaBancoModel) => a.ativo));
  };

  const carregarListaEditar = async () => {
    setSelectedOrigem([lancamentoBancarioState.detalheTransferencia.idContaBancoOrigem]);
    setSelectedDestino([lancamentoBancarioState.detalheTransferencia.idContaBancoDestino]);

    const searchEmpresaSorteios = empresaState.list.filter((empresa: any) => empresa.id === lancamentoBancarioState.detalheTransferencia.idEmpresaOrigem);
    var listIdEmpresas =
      searchEmpresaSorteios.length !== 0 ? searchEmpresaSorteios[0].id + "," + searchEmpresaSorteios[0].idEmpresaMarketing : lancamentoBancarioState.detalheTransferencia.idEmpresaOrigem.toString();
    dispatch(listarSorteio(listIdEmpresas));

    let resultOrigem = await dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: lancamentoBancarioState.detalheTransferencia.idEmpresaOrigem }));
    setBancoOrigem(resultOrigem.payload.filter((a: Vm_ContaBancoModel) => a.ativo));
    let resultDestino = await dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: lancamentoBancarioState.detalheTransferencia.idEmpresaDestino }));
    setBancoDestino(resultDestino.payload.filter((a: Vm_ContaBancoModel) => a.ativo));

    let resultSaldo = await dispatch(
      buscarSaldoContaBanco({
        idContaBanco: lancamentoBancarioState.detalheTransferencia.idContaBancoOrigem,
        data: lancamentoBancarioState.detalheTransferencia.data,
      })
    );
    form.setFieldValue("saldoDia", resultSaldo.payload.length !== 0 ? resultSaldo.payload[0].saldoFim : 0);
  };

  const submit = (values: FormProps) => {
    if (selectedDestino.length !== 0) {
      if (editar) {
        let args: TransferenciaBancariaModel = {
          id: lancamentoBancarioState.detalheTransferencia.id,
          idContaBancoOrigem: lancamentoBancarioState.detalheTransferencia.idContaBancoOrigem,
          idContaBancoDestino: lancamentoBancarioState.detalheTransferencia.idContaBancoDestino,
          data: values.data,
          idFormaPagamentoRecebimento: values.idFormaPagamentoRecebimento,
          valor: realParaNumber(values.valor.toString()),
          historico: values.historico,
          dataSorteio: values.dataSorteio,
        };
        dispatch(atualizarTransferenciaBancario({ value: args, busca: lancamentoBancarioState.busca }));
      } else {
        let args: TransferenciaBancariaModel = {
          id: null,
          idContaBancoOrigem: Number(selectedOrigem[0]),
          idContaBancoDestino: Number(selectedDestino[0]),
          data: values.data,
          idFormaPagamentoRecebimento: values.idFormaPagamentoRecebimento,
          valor: realParaNumber(values.valor.toString()),
          historico: values.historico,
          dataSorteio: values.dataSorteio,
        };
        dispatch(cadastrarTransferenciaBancaria({ value: args, busca: lancamentoBancarioState.busca }));
      }
    } else {
      toastWarning("Selecione uma conta destino");
    }
  };

  const voltar = () => {
    dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: lancamentoBancarioState.busca.idEmpresa}));
    dispatch(setModalCadastrarLancamentoBancario(false));
  };

  const changeSaldo = async (idContaBanco: number, data: Date) => {
    const retorno = await dispatch(
      buscarSaldoContaBanco({
        idContaBanco: idContaBanco,
        data: data,
      })
    );
    form.setFieldValue("saldoDia", retorno.payload.length !== 0 ? retorno.payload[0].saldoFim : 0);
  };

  const rowSelectionDestino = {
    selectedRowKeys: selectedDestino,
    onChange: (keys: React.Key[], selectedRows: any[]) => {
      setSelectedDestino(keys);
    },
    getCheckboxProps: () => ({
      disabled: editar,
    }),
  };

  const rowSelectionOrigem = {
    selectedRowKeys: selectedOrigem,
    onChange: (keys: React.Key[], selectedRows: any[]) => {
      setSelectedOrigem(keys);
      changeSaldo(Number(keys[0]), dayjs(form.getFieldValue("data")).toDate());
    },
    getCheckboxProps: () => ({
      disabled: editar,
    }),
  };

  const onChangeData = (value: DatePickerProps["value"], dateString: string | string[]) => {
    changeSaldo(parseInt(selectedOrigem[0].toString()), dayjs(value).toDate());
  };

  const onChangeEmpresaDestino = async (value: number) => {
    const retorno = await dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: value }));
    setBancoDestino(retorno.payload);
  };

  const onChangeEmpresaOrigem = async (value: number) => {
    const retorno = await dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: value }));
    setBancoOrigem(retorno.payload);
  };

  const columnsOrigem: ColumnsType<Vm_ContaBancoModel> = [
    {
      title: "CONTA ORIGEM",
      dataIndex: "denominacaoPersonalizada",
      sorter: (a, b) => a.denominacaoPersonalizada.localeCompare(b.denominacaoPersonalizada),
      sortDirections: ["ascend", "descend", "ascend"],
      onCell: (record) => {
        return {
          onClick: () => {
            if (!editar) {
              setSelectedOrigem([record.id]);
              changeSaldo(record.id, dayjs(form.getFieldValue("data")).toDate());
            }
          },
        };
      },
    },
  ];

  const columnsDestino: ColumnsType<Vm_ContaBancoModel> = [
    {
      title: "CONTA DESTINO",
      dataIndex: "denominacaoPersonalizada",
      sorter: (a, b) => a.denominacaoPersonalizada.localeCompare(b.denominacaoPersonalizada),
      sortDirections: ["ascend", "descend", "ascend"],
      onCell: (record) => {
        return {
          onClick: () => {
            if (!editar) {
              setSelectedDestino([record.id]);
            }
          },
        };
      },
    },
  ];

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col span={24}>
          <h3>Selecione a conta origem, conta destino, informe o valor e data de transferência.</h3>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item name="idEmpresaO" label="Empresa de origem" style={{ marginLeft: "6px" }}>
            <Select
              showSearch
              optionFilterProp="labelSearch"
              placeholder="Selecione uma empresa"
              loading={empresaState.loading}
              onChange={onChangeEmpresaOrigem}
              style={{ width: "100%" }}
              options={empresaState.list.map((a: EmpresaModel) => ({
                value: a.id,
                key: a.apelido,
                label: (
                  <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                    <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                    {a.apelido}
                  </Flex>
                ),
                labelSearch: a.apelido,
              }))}
              disabled={editar}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="idEmpresaD" label="Empresa de destino" style={{ marginLeft: "6px" }}>
            <Select
              showSearch
              optionFilterProp="labelSearch"
              placeholder="Selecione uma empresa"
              loading={empresaState.loadingAll}
              onChange={onChangeEmpresaDestino}
              style={{ width: "100%" }}
              options={empresaState.listAll.map((a: EmpresaModel) => ({
                value: a.id,
                key: a.apelido,
                label: (
                  <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                    <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                    {a.apelido}
                  </Flex>
                ),
                labelSearch: a.apelido,
              }))}
              disabled={editar}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={12}>
          <Table
            size="small"
            className="tableLancamento cad"
            dataSource={bancoOrigem}
            columns={columnsOrigem}
            loading={contaBancoState.loading}
            rowKey="id"
            showSorterTooltip={false}
            pagination={false}
            rowSelection={{
              type: "radio",
              ...rowSelectionOrigem,
            }}
            scroll={{ y: 200 }}
          />
        </Col>
        <Col span={12}>
          <Table
            size="small"
            className="tableLancamento cad"
            dataSource={bancoDestino}
            columns={columnsDestino}
            loading={contaBancoState.loading}
            rowKey="id"
            showSorterTooltip={false}
            pagination={false}
            rowSelection={{
              type: "radio",
              ...rowSelectionDestino,
            }}
            scroll={{ y: 200 }}
          />
        </Col>
      </Row>
      <Divider />
      <Row>
        <div style={{ width: "950px", display: "flex", justifyContent: "space-between" }}>
          <Col span={4}>
            <Form.Item label="Data do lançamento" name="data">
              <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" onChange={onChangeData} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Saldo no dia" name="saldoDia">
              <NumericFormat
                style={{ width: "100%" }}
                className="ant-input noBoderColor number-input"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                prefix="R$"
                disabled
                fixedDecimalScale={true}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Data do sorteio" name="dataSorteio">
              <DatePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label="Forma de pagamento"
              name="idFormaPagamentoRecebimento"
              rules={[
                {
                  required: true,
                  message: "Escolha uma forma de pagamento",
                },
              ]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Selecione uma forma de pagamento"
                loading={formaPagamentoRecebimentoState.loading}
                style={{ width: "100%" }}
                options={formaPagamentoRecebimentoState.list.map((formaPagamento: FormaPagamentoRecebimentoModel) => ({
                  value: formaPagamento.id,
                  label: formaPagamento.denominacao,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="Valor a transferir"
              name="valor"
              rules={[
                {
                  required: true,
                  message: "Digite um valor a ser transferido",
                },
              ]}
            >
              <NumericFormat
                style={{ width: "100%" }}
                className="ant-input noBoderColor number-input"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                prefix="R$"
                fixedDecimalScale={true}
              />
            </Form.Item>
          </Col>
        </div>
        <Col span={1}></Col>
      </Row>
      <Row gutter={12} align="bottom">
        <Col span={24}>
          <Form.Item label="Histórico" name="historico">
            <Input type="text" />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default ModalLançamento;
